export const password = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,15}$/;
export const mobileNumber = /^[0-9]{10}$/;
export const search = /^.{6}$/;
export const fullName = /^[A-Za-z\s]+$/;
export const email = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
export const address = /^[A-Za-z0-9\s,.\-!@#$%^&*()_+=\[\]{}|\\;:'"`~<>?/]+$/;
export const country = /^[A-Za-z\s]+$/;
export const state = /^[A-Z\s\-]+$/i;
export const city = /^[A-Za-z\s,]+$/;
export const pinCode = /^[A-Z0-9\s\-]{4,10}$/;
export const mapLink = /^(https?:\/\/)?([\w\-]+(\.[\w\-]+)+)(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/;
